<template>
  <div class="policy container">
    <div
      class="policy-search py-4"
      :class="{ 'm-policy-search': focusOnSearch }"
      @click.self="closeSearch"
    >
      <a-input-search
        class="search"
        placeholder="请输入你想查阅的资讯"
        enter-button="搜索"
        v-model="search"
        size="large"
        @focus="showHotList"
        @search="onSearch"
      />
      <div class="hot-list pl-3" v-if="searchInfoList">
        <p class="title mr-4">热门搜索</p>
        <template
          v-for="(item, index) in searchInfoList.search_key.split('，')"
        >
          <p class="mr-4" :key="index" @click="searchTest(item)">{{ item }}</p>
        </template>
      </div>
      <div class="m-hot-list" v-if="searchInfoList">
        <p class="title mr-4">热门搜索</p>
        <template
          v-for="(item, index) in searchInfoList.search_key.split('，')"
        >
          <p class="mr-4" :key="index" @click="searchTest(item)">{{ item }}</p>
        </template>
      </div>
    </div>
    <div class="policy-list">
      <template v-for="(item, index) in articleList">
        <div class="item" :key="index" @click="toArticle(item.id)">
          <div class="top">
            <div class="title">
              <a-tag class="tag" :color="item.flag_name | getColor">{{
                item.flag_name
              }}</a-tag>
              <p>{{ item.title }}</p>
            </div>
            <p class="number">
              <img src="@/assets/image/message1.png" />{{
                item.view_num | addNumber
              }}
            </p>
          </div>
          <div class="desc" v-html="item.guide"></div>
        </div>
      </template>

      <template v-if="articleList.length == 0">
        <div class="no-case-list py-5">
          <img src="@/assets/image/noDate.png" />
        </div>
      </template>
    </div>
    <div class="policy-page">
      <a-pagination
        @change="selectPage"
        hideOnSinglePage
        :current="page"
        :pageSize="limit"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      focusOnSearch: false,
      search: "",
      limit: 8,
      page: 1,
      total: 0,
      articleList: [],
      searchInfoList: null,
    };
  },
  filters: {
    getColor(val) {
      // return 'pink'
      switch (val) {
        case "热门":
          return "red";
          break;
        case "首页":
          return "pink";
          break;
        case "推荐":
          return "orange";
          break;
        case "官方":
          return "red";
          break;
        case "资讯":
          return "green";
          break;
        case "知识":
          return "cyan";
          break;
        case "政策":
          return "blue";
          break;
        case "问题":
          return "purple";
          break;
        case "行业":
          return "blue";
          break;
        case "标准":
          return "blue";
          break;
        default:
          return "blue";
      }
    },
    addNumber(val) {
      return val + Math.floor(Math.random() * 1000) + 100;
    },
  },
  methods: {
    closeSearch() {
      this.focusOnSearch = false;
      document.body.style.overflow = "auto";
    },
    showHotList() {
      if (this.$mobile) {
        document.body.style.overflow = "hidden";
      }
      this.focusOnSearch = true;
    },
    searchTest(val) {
      document.body.style.overflow = "auto";
      this.focusOnSearch = false;
      this.search = val;
      this.getArticleList();
    },
    getSearchInfo() {
      this.$api
        .getSearchInfo({
          type: 20,
        })
        .then((res) => {
          this.searchInfoList = res.data;
        });
    },
    getArticleList() {
      this.$api
        .getArticleList({
          except: "case",
          page: this.page,
          limit: this.limit,
          search: this.search,
        })
        .then((res) => {
          this.articleList = res.data.list;
          this.total = res.data.total;
        });
    },
    onSearch(val) {
      this.focusOnSearch = false;
      this.search = val;
      this.getArticleList();
    },
    toArticle(id) {
      this.$router.push({
        name: "article",
        query: {
          id: id,
          except: "case",
        },
      });
    },
    selectPage(index) {
      this.page = index;
      this.getArticleList();
    },
  },

  created() {
    this.getArticleList();
    this.getSearchInfo();
  },
};
</script>

<style lang="scss">
@import "@/assets/css/policy.scss";
</style>
